import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { SsspModel } from 'src/app/models/sssp-model';
import { ApiRequestService } from 'src/app/shared/api-request.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { RBACService } from 'src/app/shared/rbac.service';

@Component({
  selector: 'app-sssp-config',
  templateUrl: './sssp-config.component.html',
  styleUrls: ['./sssp-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SsspConfigComponent implements OnInit {
  @Input('sssp_hash') sssp_hash: string;

  sssp: SsspModel = new SsspModel();
  hasPermission: boolean = false;

  constructor(
    public app: AppService,
    public api: ApiRequestService,
    public utils: UtilsService,
    private rbac: RBACService
  ) {}

  // Expose RBACService to template
  protected readonly RBACService = RBACService;

  ngOnInit() {
    // Check if user has edit permission from any perspective
    this.hasPermission = this.canEditSafetyPlans();

    if (!this.hasPermission) {
      this.utils.showModal(
        'Access Denied',
        'You do not have permission to edit safety plan configuration.'
      );
      return;
    }

    this.getSssp();
  }

  /**
   * Check if user can edit safety plans from any perspective
   */
  canEditSafetyPlans(): boolean {
    return (
      this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES_SAFETY_PLANS,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      ) ||
      this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_CONTRACTORS_SAFETY_PLANS,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      ) ||
      this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_SAFETY_PLANS,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      ) ||
      this.rbac.userCanAccess(
        [
          RBACService.getPermission(
            RBACService.RBAC_F.F_CLIENT_SITES,
            RBACService.RBAC_A.A_EDIT
          )
        ],
        true
      )
    );
  }

  /**
   * Get the Safety Plan based on the hash that is provided
   */
  getSssp() {
    return this.api
      .makeRequest('get', `v1/sssp/${this.sssp_hash}`)
      .then((response) => {
        this.sssp.apply(response);
      })
      .catch((errorResponse) => {
        this.utils.showModal('Error', errorResponse.error.message);
      });
  }

  /**
   *
   * @param form The form data to validate if any.
   */
  onSave(form: NgForm) {
    // Check permission before saving
    if (!this.canEditSafetyPlans()) {
      this.rbac.showGenericAccessDeniedMessage(
        'You do not have permission to edit safety plan configuration.'
      );
      return;
    }

    if (!form.valid) {
      // Form validation failed.
    }

    this.api
      .makeRequest('put', `v1/sssp/${this.sssp_hash}`, this.sssp)
      .then((response) => {
        this.sssp.apply(response);
        this.utils.showToast('The configuration was saved successfully.');
      })
      .catch((errorResponse) => {
        this.utils.showModal('Error', errorResponse.error.message);
      });
  }
}
